export function sendEventsList(eventsList, params){
    if(Array.isArray(eventsList)) {
        eventsList.forEach(event => EventBus.$emit(event, params));
    }
}
